import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { ENTITY_TYPES } from "../../../utils";

function ColumnHeader({ entity = "" }) {
  const [hasScrollbar, setHasScrollbar] = useState(false);

  useEffect(() => {
    const listContainer = document.getElementsByClassName(
      "ReactVirtualized__List"
    )[0];
    const isScrollbar = () => {
      if (listContainer) {
        return listContainer?.scrollHeight > listContainer?.clientHeight;
      }
      return false;
    };
    // Threshold for rendering
    setTimeout(() => {
      setHasScrollbar(isScrollbar());
    }, 100);
  }, []);

  return (
    <Grid
      container
      columnGap={0.3}
      alignItems="center"
      justifyContent="space-between"
      sx={{ fontSize: "12px", fontWeight: 600, alignItems: "flex-end" }}
    >
      {entity === ENTITY_TYPES.planogram ? (
        <>
          <Grid item xs={0.22}></Grid>
          <Grid item xs={0.45}>
            Pog #
          </Grid>
          <Grid item xs={1.65}>
            Pog Name
          </Grid>
          <Grid item xs={1.38}>
            Department
          </Grid>
          <Grid item xs={1.38}>
            Category
          </Grid>
          <Grid item xs={0.18}>
            OSO Sel.
          </Grid>
          <Grid item xs={0.4}>
            Selected
          </Grid>
          <Grid item xs={0.45}>
            Total
          </Grid>
          <Grid item xs={0.4}>
            Qty
          </Grid>
          <Grid item xs={0.61}>
            SS POG Cost
          </Grid>
          <Grid item xs={0.63}>
            Acq Cost
          </Grid>
          <Grid item xs={0.45}>
            Adj Qty
          </Grid>
          <Grid item xs={0.55}>
            Adj Cost
          </Grid>
          <Grid item xs={0.7}></Grid>
        </>
      ) : (
        <>
          <Grid item xs={0.15}></Grid>
          <Grid item xs={hasScrollbar ? 2.12 : 2.13}>
            Fixture Name
          </Grid>
          <Grid item xs={hasScrollbar ? 0.35 : 0.38}>
            POG #
          </Grid>
          <Grid item xs={0.28}>
            SKU
          </Grid>
          <Grid item xs={0.38}>
            Is Free
          </Grid>
          <Grid item xs={hasScrollbar ? 0.23 : 0.25}>
            OSO Sel.
          </Grid>
          <Grid item xs={0.22}>
            Select
          </Grid>
          <Grid item xs={hasScrollbar ? 0.32 : 0.34}>
            Qty
          </Grid>
          <Grid item xs={hasScrollbar ? 0.16 : 0.14}>
            Pack
          </Grid>
          <Grid item xs={0.71}>
            Member Cost
          </Grid>
          <Grid item xs={hasScrollbar ? 0.71 : 0.73}>
            Acq Cost
          </Grid>
          <Grid item xs={hasScrollbar ? 0.41 : 0.43}>
            Adj Qty
          </Grid>
          <Grid item xs={0.72}>
            Adj Cost
          </Grid>
          <Grid item xs={hasScrollbar ? 0.95 : 0.8}>
            Type
          </Grid>
          <Grid item xs={0.4}></Grid>
        </>
      )}
    </Grid>
  );
}

export default ColumnHeader;
